import React from 'react';

import TeamMoodRow from './TeamMoodRow';

function TeamMoodRowContainer({
  emotionsArray = [],
  mood,
  question,
  index,
  handleMood,
  isSummary,
}) {
  const defaultMoods = ['happy', 'neutral', 'sad'];

  const getStatistics = () => {
    const statistics = {
      happy: 0,
      neutral: 0,
      sad: 0,
      total: 0,
    };

    if (emotionsArray.length > 0 && question) {
      const emotions = emotionsArray.find((m) => m.question === question);

      for (const m of emotions.participantEmotions) {
        statistics[m] += 1;
        statistics.total += 1;
      }

      for (const dM of defaultMoods)
        statistics[dM] = `${Number.parseFloat(
          ((statistics[dM] / statistics.total) * 100).toFixed(1)
        )}%`;
    }
    // eslint-disable-next-line no-return-assign
    else for (const dM of defaultMoods) statistics[dM] = `${statistics[dM]}%`;
    return statistics;
  };

  return (
    <TeamMoodRow
      index={index}
      question={question}
      defaultMoods={defaultMoods}
      mood={mood}
      handleMood={handleMood}
      statistics={getStatistics()}
      isSummary={isSummary}
    />
  );
}

export default TeamMoodRowContainer;
